import { render, staticRenderFns } from "./AmountDisplayer.vue?vue&type=template&id=10797bb3&scoped=true"
import script from "./AmountDisplayer.vue?vue&type=script&lang=ts"
export * from "./AmountDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./AmountDisplayer.vue?vue&type=style&index=0&id=10797bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10797bb3",
  null
  
)

export default component.exports